import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=0bb064d4&scoped=true"
import script from "./ToolBar.vue?vue&type=script&lang=js"
export * from "./ToolBar.vue?vue&type=script&lang=js"
import style0 from "./ToolBar.vue?vue&type=style&index=0&id=0bb064d4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb064d4",
  null
  
)

export default component.exports